<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '1000px' }"
  [contentStyle]="{ minHeight: 'calc(100vh - 850px)' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [customFormControls]="{
        clinicID: clinicID
      }"
    >
      <ng-template
        #clinicID
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
        <ng-container [formGroup]="formGroup">
          <app-clinic-dropdown
            *ngIf="isClinicDropdownVisible()"
            [label]="config.label"
            [class]="styleClass"
            [config]="config"
            formControlName="clinicID"
            [hospitalId]="tokenData?.hospitalId"
            [showClear]="true"
          />
        </ng-container>
      </ng-template>
    </eo-form>
  </div>
</p-dialog>
